// extracted by mini-css-extract-plugin
module.exports = {"awardSectionWrapper":"AwardSection_awardSectionWrapper__2CNK-","bulletPoints":"AwardSection_bulletPoints__1-flq"};